<template>

    <div id="konfigurator-suroviny">

        <h1>Jaký bude váš Pettime?</h1>

        <div class="error-msg" v-if="errorMessage">{{ errorMessage }}</div>

        <div v-show="!isStepValid() && this.tryEscape" class="info-messages-box">
            <div v-if="!isStepValid() && this.tryEscape" class="error-msg">
                Vyberte jednu z možností
            </div>
            <div v-if="!existValidOption">Pro vašeho psa nedokážeme vytvořit krmivo.</div>
        </div>

        <div v-if="typSlozkyItems" class="form-content">
        <div class="summary-subtitle">Doporučujeme předvybraný Pettime, který obsahuje vše, co váš pes aktuálně potřebuje a za výhodnou cenu.</div>
            <div class="suroviny">
                <div v-if="typSlozkyItems[0]" class="suroviny-skupina">
                    <div class="form-radios" v-bind:class="{ 'has-error':!isMasovaValid() && this.tryEscape }">
                        <div v-for="(item, index) in typSlozkyItems[0].items"
                             :class="{'form-type-radio' : true,
                              'form-type-radio-disabled': item.alergic || item.status == 0,
                              'pripravujeme': item.status == 0,
                              'smaller': index > 0,
                              }"
                             :key="item.id">
                            <input type="radio" :name="typSlozkyItems[0].id_typ_slozky"
                                   v-model="mazlicek.suroviny.slozky[typSlozkyItems[0].id_typ_slozky]"
                                   v-bind:value="item.id" :id="item.id" :disabled="item.alergic || item.status == 0">
                            <label :for="item.id">
                                <div class="item-title">{{ item.title }}</div>
                                <div v-if="item.description.length > 0" class="item-desc"
                                     v-html="item.description"></div>
                                <div v-if="item.alergic" class="suroviny-alergic-info"><div class="suroviny-alergic-info-icn"></div><div class="suroviny-alergic-info-desc">Obsahuje vyloučenou surovinu</div></div>
                                <div v-if="item.status == 0" class="suroviny-pripravujeme-info"><div class="suroviny-pripravujeme-info-icn"></div><div class="suroviny-pripravujeme-info-desc">Připravujeme</div></div>
                                <img v-if="item.filename" :src="getSlozkaImageUrl(item.filename)"/>
                            </label>
                            <div v-show="index === 0" class="dalsi-suroviny-info">
                              Možné úpravy <span class="parentheses">(zvýšení ceny)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <info :krok="9"></info>
        <confirmation-modal v-if="priceConfirmation.showModal"
                            :old-price="priceConfirmation.oldPrice" :new-price="priceConfirmation.newPrice"
                            :confirm-callback="updateProductAndQuit" @close="priceConfirmation.showModal = false"/>
        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :disableNext="!valid"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>

    </div>

</template>

<script>
import {validationMixin} from 'vuelidate'
import {apiSilex} from '../api'
import navigace from './Navigace'
import info from './Info'
import ConfirmationModal from "./ConfirmationModal";

export default {
        components: {ConfirmationModal, navigace, info},
        mixins: [validationMixin],
        data: function () {
            return {
                mazlicek: this.$store.state.mazlicek,
                typSlozkyItems: [],
                slozkaItemsPetIsAlergicTo: null,
                // slozkaItems: [],
                // test: {},
                tryEscape: false,
                errorMessage: '',
                priceConfirmation: {
                    showModal: false,
                    differentPrice: false,
                    oldPrice: 0,
                    newPrice: 0,
                }
            }
        },
        computed: {
            valid: function () {
                return (this.mazlicek.suroviny.valid = !this.$v.mazlicek.suroviny.$invalid)
            },
            existValidOption() {
                let exist = true

                this.typSlozkyItems.forEach((itemType) => {
                    let noAlergicItem = itemType.items.find((item) => item.alergic == false)
//                    console.log(itemType.items)
                    exist = exist && (noAlergicItem !== undefined)
                })
                return exist
            }
        },
        methods: {
          getSlozkaImageUrl(filename) {
            if (filename) {
              return '/sites/default/files/aplikace/slozka/' + filename
            } else {
              return '';
            }
          },
            /*
            onSurovinaChange: function (id, typ) {
              this.mazlicek.suroviny.suroviny.forEach(function (entry) {
                if (entry.id_typ_slozky === typ) {
                  var index = entry.items.indexOf(id)
                  if (index === -1) {
                    entry.items.push(id)
                  } else {
                    entry.items.splice(index, 1)
                  }
                }
              })
            },
            */
//            getTypSlozkyItems: function (typ) {
//                var a = []
//                this.slozkaItems.forEach(function (entry) {
//                    if (entry.id_typ_slozky === typ) {
//                        entry.is_alergic = (this.mazlicek.alergie.alergeny.indexOf(entry.id) != -1) ? true : false
//                        a.push(entry)
//                    }
//                })
//                return a
//            },
            prev: function () {
                this.$router.push({name: 'alergie'})
            },
            isMasovaValid: function () {
                let keys = Object.keys(this.mazlicek.suroviny.slozky)
                return keys.includes('1')
            },
            isPrilohaValid: function () {
                let keys = Object.keys(this.mazlicek.suroviny.slozky)
                return keys.includes('2')
            },
            isMineralniValid: function () {
                let keys = Object.keys(this.mazlicek.suroviny.slozky)
                return keys.includes('3')
            },
            isSelectedValuesValid: function () {
              if(this.slozkaItemsPetIsAlergicTo){
                let meatItemsContainingAlergens = this.slozkaItemsPetIsAlergicTo.filter(item => item.id === this.mazlicek.suroviny.slozky[1])
                let sideDishItemsContainingAlergens = this.slozkaItemsPetIsAlergicTo.filter(item => item.id === this.mazlicek.suroviny.slozky[2])
                return meatItemsContainingAlergens.length === 0 && sideDishItemsContainingAlergens.length === 0
              }
            },
            isStepValid: function () {
                return this.isMasovaValid() && this.isSelectedValuesValid()
            },
            isPetAlergicOnNutrition(nutrition) {
                let isAlergic = this.slozkaItemsPetIsAlergicTo.find(item => item.id === nutrition.id)

                return isAlergic !== undefined
            },

            async loadNutritionGroupByTypes() {

              let slozky = await apiSilex.get('/slozka')
              .then(response => {
                let slozky = response.data
                if (!this.mazlicek.suroviny.slozky[1]) {
                  let defaultSlozka = slozky.find(item => item.id_typ_slozky === "1")

                  this.mazlicek.suroviny.slozky[1] = defaultSlozka.id
                }

                return slozky
              })
              .catch(error => console.log(error))

              apiSilex.get('/typ_slozky')
              .then(response => {
                this.typSlozkyItems = response.data
                this.typSlozkyItems.forEach(typSlozky => {
                  typSlozky.items = []

                  typSlozky.items = slozky.filter(item => {
                    item.alergic = this.isPetAlergicOnNutrition(item)

                    return item.id_typ_slozky == typSlozky.id_typ_slozky
                  })

                  this.$forceUpdate()
                })
              })
              .catch(error => console.log(error))
            },
            updateProductAndQuit: function () {
                this.mazlicek.confirmToSave = false
                this.$store.dispatch('updateProduct', this.mazlicek)
                  .then(response => {
                    this.mazlicek.suroviny.valid = true
                    this.mazlicek.krmivo.feedData = response.data.data.feedData
                    this.mazlicek.krmivo.cena.den = this.mazlicek.krmivo.feedData.feedRatio.totalPrice
                    this.$store.commit('setMazlicek', this.mazlicek)
                    this.$cookies.set('show_confirmation_message', 1)
                    window.location.href = 'opet-objednej/' + this.mazlicek.nid
                  }, error => {
                    console.error(error)
                  })
            },
            saveAndQuit: function () {
              if (this.isStepValid()) {
                this.mazlicek.suroviny.slozky[3] = 0
                this.mazlicek.confirmToSave = true

                this.$store.dispatch('updateProduct', this.mazlicek)
                  .then(response => {
                    if (response.data.status.code != 200) return this.errorMessage = response.data.status.message

                    const confirmation = response.data.data.priceConfirmation;
                    if (confirmation && confirmation.differentPrice) {
                        this.priceConfirmation.oldPrice = confirmation.oldPrice;
                        this.priceConfirmation.newPrice = confirmation.newPrice;
                        this.priceConfirmation.showModal = true
                    } else {
                        this.updateProductAndQuit()
                    }

                  })
                  .catch(error => {
                    console.error(error)
                  })
              } else {
                this.tryEscape = true
                this.animateAfterError()
              }
            },
            next: function () {
                if (this.isStepValid()) {
                    this.mazlicek.suroviny.slozky[3] = 0

                    this.$store.dispatch('updateProduct', this.mazlicek)
                      .then(response => {
                        if (response.data.status.code != 200) return this.errorMessage = response.data.status.message

                        let krmivo = response.data.data.product.node
                        this.$store.state.mazlicek.orderData.isFirstOrder = krmivo.order_data.is_first_order
                        this.$store.state.mazlicek.orderData.firstOrderPrice = krmivo.order_data.first_order_price

                        this.mazlicek.suroviny.valid = true
                        this.mazlicek.krmivo.feedData = response.data.data.feedData
                        this.mazlicek.krmivo.cena.den = this.mazlicek.krmivo.feedData.feedRatio.totalPrice
                        this.$store.commit('setMazlicek', this.mazlicek)
                        this.$router.push({name: 'hotovekrmivo'})
                      })
                      .catch(error => {
                        console.error(error)
                      })
                } else {
                    this.tryEscape = true
                    this.animateAfterError()
                }
            },
            animateAfterError(){
                jQuery('html, body').animate({
                        scrollTop: jQuery('.app-content-left').offset().top - jQuery('#primary').height()
                    },
                    '500'
                )
            },
            mountinMethod(){
                this.mazlicek.step.current = 8
                this.$cookies.set('lastVisitedStep', 8)
                jQuery('html, body').animate({scrollTop: 0}, '500')
                let url = '/slozka?is-alergic=true&alergen=' + this.mazlicek.alergie.alergeny.toString()
                apiSilex.get(url).then(response => {
                    this.slozkaItemsPetIsAlergicTo = response.data
                    this.loadNutritionGroupByTypes()
                })
            }
        },
        mounted: function () {
            this.mountinMethod()
        },
        validations: {
            mazlicek: {
                suroviny: {
                    valid: function () {
                        let keys = Object.keys(this.mazlicek.suroviny.slozky)

                        return (keys.length === this.typSlozkyItems.length)
                    }
                }
            }
        },
        watch: {
            'mazlicek.productLoaded': {
                deep: true,
                handler: function (val) {
                    if (val.value)
                        this.mountinMethod()
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// 09Suroviny.vue?4ab1c033